import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";

let cache = null;
let pending = null;

export function useChannelAccounts() {
  const [accounts, setAccounts] = useState(cache || []);
  useEffect(() => {
    if (cache) return;
    pending = pending || api.get("/channel-accounts/labels").then(({ data }) => (cache = data)).catch(() => (cache = []));
    pending.then((d) => setAccounts(d));
  }, []);
  return accounts;
}

export function accountFor(accounts, channel, accountId) {
  return accounts.find((a) => a.id === accountId) || accounts.find((a) => a.channel === channel && a.is_default);
}

/** Shows which connected account (IG, WhatsApp number, Page) a conversation belongs to — only when a channel has several. */
export const AccountTag = ({ channel, accountId, testId }) => {
  const accounts = useChannelAccounts();
  const acc = accountFor(accounts, channel, accountId);
  if (!acc || !acc.multi) return null;
  return (
    <span className="inline-flex items-center rounded px-1.5 py-0 text-[10px] font-medium bg-secondary text-secondary-foreground border border-border truncate max-w-[140px]"
      title={`Cuenta: ${acc.label}`} data-testid={testId}>
      {acc.label}
    </span>
  );
};

export default AccountTag;
